module.exports = __webpack_public_path__ + "img/slide-01.c6fbf034.jpg";